import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HiddenCallbackComponent } from '../components/hidden-callback/hidden-callback.component';
import { TextCallbackComponent } from '../components/text-callback/text-callback.component';
import { NoUrlFoundComponent } from '../components/no-url-found/no-url-found.component';

@NgModule({
  declarations: [
    HiddenCallbackComponent,
    TextCallbackComponent,
    NoUrlFoundComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  exports: [
    HiddenCallbackComponent,
    TextCallbackComponent,
    NoUrlFoundComponent
  ]
})
export class SharedModule { }
